import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { WarehouseSensorAddComponent } from './warehouse-sensor-add/warehouse-sensor-add.component';
import { Router, ActivatedRoute } from '@angular/router';
import { faBuilding, faThermometer } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { ActionButton } from '../../../../../common/interfaces/global-interfaces';
import { NotificationService } from '../../../../../services/notification.service';
import { SettingsService } from '../../../../../services/settings.service';
import { TableConfiguration } from '../../../../../shared/components/paginated-data-table/paginated-table-configuration.model';
import { AppState } from '../../../../../store';
import { StoreItemActions } from '../../../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../../../store/entities/store-item/store-item.model';
import { GET_ZONE_DATA, DELETE_ZONE_MUTATION } from '../../../../../store/entities/warehouse-management/building-zone/building-zone.graphql';
import { DELETE_WAREHOUSE_SENSOR_MUTATION, GET_ALL_SENSORS } from '../../../../../store/entities/warehouse-management/device/device.graphql';
import { WarehouseZone } from "../../../../../store/entities/warehouse-management/building-zone/building-zone.model";
import { Device } from '../../../../../store/entities/warehouse-management/device/device.model';
import {
  ZoneSensorAddComponent
} from "../warehouse-zone-list/warehouse-zone-view/zone-sensor-list/zone-sensor-add/zone-sensor-add.component";
import { WarehouseSensorAlertComponent } from "./warehouse-sensor-alert/warehouse-sensor-alert.component";
import { Subscription } from 'rxjs';
import { Bins } from '../warehouse-zone-list/warehouse-zone-view/bin-list/bin-list.component';
export interface Sensor {
  sensorUniqueId: string;
  sensorIp: string;
  serialNumber: string;
  coveredBins: CoveredBin[];
}

export interface CoveredBin {
  id: string;
  uniqueId: string;
  binNumber: string;
  isActive: boolean;
}

@Component({
  selector: 'app-warehouse-sensor-list',
  templateUrl: './warehouse-sensor-list.component.html',
  styleUrl: './warehouse-sensor-list.component.scss'
})
export class WarehouseSensorListComponent implements OnInit, OnDestroy {
  private settingService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);
  @Input() refresh: boolean = false
  routerSub = Subscription.EMPTY;
  bins: Sensor[]=[
    
                {
                    "sensorUniqueId": "545186686906722990",
                    "sensorIp": "192.168.35.170",
                    "serialNumber": "GMHT01:8E06249",
                    "coveredBins": [
                        {
                            "id": "27345",
                            "uniqueId": "2456866521735296189",
                            "binNumber": "BA01A",
                            "isActive": true
                        },
                         {
                            "id": "27345",
                            "uniqueId": "2456866521735296189",
                            "binNumber": "BA01A",
                            "isActive": true
                        },
                         {
                            "id": "27345",
                            "uniqueId": "2456866521735296189",
                            "binNumber": "BA01A",
                            "isActive": true
                        },
                         {
                            "id": "27345",
                            "uniqueId": "2456866521735296189",
                            "binNumber": "BA01A",
                            "isActive": true
                        }
                    ]
                }
  ];
  @Input() sensors: any[] = [];
  query;
  addPermission: string[] = ["can_create_sensor"];
  private notificationService: NotificationService =
    inject(NotificationService);
  constructor(private store: Store<AppState>, private active: ActivatedRoute) { }
  refreshDataTable: boolean = false;
  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "sensorName", label: "Name" },
      { name: "serialNumber", label: "Serial Number" },
      { name: "sensorType", label: "Sensor Type" },
      { name: "sensorLocation", label: "Sensor Location" },
      // { name: "bins", label: "Bins", type:'array' },
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  actionButtons: ActionButton[] = [
    {
      id: "more",
      label: "View More",
      title: "View More",
      class: "",
      icon: "list",
      action: "more",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "coverage",
      label: "Configure Coverage",
      title: "Configure Covarege",
      class: "",
      icon: "settings",
      action: "coverage",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "notification",
      label: "Set Alert",
      title: "Set Alert",
      class: "",
      icon: "add_alert",
      action: "notification",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "edit",
      label: "Edit",
      title: "Edit",
      class: "",
      icon: "edit",
      action: "edit",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "delete",
      label: "Delete",
      title: "Delete",
      class: "",
      icon: "delete",
      action: "delete",
      confirm_first: false,
      loading_message: "",
    },
  ];

  filteredBins(item:Device){
     return this.bins.filter((bin)=>(bin.sensorUniqueId == item.uniqueId))
  }
  mapFunction = (item: Device) => {
    
    return {
      ...item,
      bins: this.filteredBins(item)?.map((sensor)=>sensor.coveredBins.map(coveredBin=>coveredBin.binNumber))
    };
  };
  filters = {
    pageNumber: 1,
    warehouse: this.active.snapshot.queryParams["id"],
  };
  permissions = {
    more: ["can_view_sensor"],
    coverage: ["can_view_sensor"],
    notification: ["can_configure_sensor"],
    edit: ["can_edit_sensor"],
    delete: ["can_delete_sensor"],
  };
  id
  ngOnInit() {
    this.id = this.active.snapshot.queryParams["id"]
    this.routerSub = this.active.queryParams.subscribe((qParams) => {
      if (qParams) {
        this.changeFilters({ warehouse: qParams['id'] })
      }
    })
    this.query = GET_ALL_SENSORS;
  }

  changeFilters(newFilters) {
    this.filters = newFilters
  }

  onAdd(data = null) {
    this.settingService.openDialogModal({
      component: WarehouseSensorAddComponent,
      data: {
        ...data,
        warehouse: this.active.snapshot.queryParams["id"]
      },
    });
  }
  onAddNotifications(data = null) {
    this.settingService.openDialogModal({
      component: WarehouseSensorAlertComponent,
      data: {
        ...data,
        warehouse: this.id
      },
    });
  };
  onDelete = (data) => { };
  onCustomAction(evt: any) {
    switch (evt?.action) {
      case "more":
        this.router.navigate(
          ["/manage/warehouse-management/warehouse-list/sensor-view/"], { queryParams: { warehouse: this.active.snapshot.queryParams['id'], sensor: evt?.value?.uniqueId } }
        );
        break;
      case "coverage":
        this.router.navigate(
          ["/manage/warehouse-management/warehouse-list/sensor-bins-mapping/"], { queryParams: { warehouse: this.active.snapshot.queryParams['id'], sensor: evt?.value?.uniqueId } }
        );
        break;
      case "notification":
        this.onAddNotifications(evt?.value);
        break;
      case "edit":
        this.onAdd(evt.value);
        break;
      case "delete":
        this.notificationService
          .confirmation({ message: "Are you sure you want to delete?" })
          .then((result) => {
            if (result) {
              this.store.dispatch(
                StoreItemActions.removeStoreItem({
                  entity: StoreItemEntity.device,
                  id: evt.value.id,
                  input: { uniqueId: evt.value.uniqueId },
                  mutation: DELETE_WAREHOUSE_SENSOR_MUTATION,
                })
              );
            }
            else {

            }
          });
    }
  }
  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }
  upsertAction = StoreItemActions.upsertStoreItem
  deleteAction = StoreItemActions.deleteStoreItem
  protected readonly faThermometer = faThermometer;
}
